import { render, staticRenderFns } from "./TabPromotionComponent.vue?vue&type=template&id=727855fc&scoped=true"
import script from "./TabPromotionComponent.vue?vue&type=script&lang=js"
export * from "./TabPromotionComponent.vue?vue&type=script&lang=js"
import style0 from "./TabPromotionComponent.vue?vue&type=style&index=0&id=727855fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727855fc",
  null
  
)

export default component.exports